export function addDecimalSeparator(x: string | number, precision: number | null = null) {
  const str = (precision === null) ? x.toString() : (Number(x) === 0 ? '0' : Number(x).toFixed(precision))

  return str.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0')
}
